import React from "react";
import {
  Excel,
  FolderIcon,
  ImageBlank,
  JPG,
  GreyDownloadIcon,
  OpenFolder,
  Pdf,
  Png,
  Ppt,
  RenameFolderIcon,
  RenameIcon,
  Word,
  deleteIcon,
  tableEditIcon,
  HideIcon,
  grayViewIcon,
} from "../../../assets/images";
import moment from "moment";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";
import { Link } from "react-router-dom";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AnyAaaaRecord } from "dns";

type Appprops = {
  tableHeader: any[];
  childFiles: any;
  handleToggleViewMoreFiles?: () => void;
  handleSetViewMoreFileId?: (file_id: number | null | undefined) => void;
  toggleRenameFileModal?: () => void;
  showViewMoreFiles: boolean;
  viewMoreFileId?: number | null | undefined;
  handleSetFileRenameModalData?: (data: any) => void;
  type?: string;
  flag?: boolean;
  setFlag?: (data: boolean) => void;
  showDeleteIcon?: boolean;
  folder?: childFolderType;
  folderId?: number;
  client_code?: string | number | null;
  history?: any;
  company_name?: string;
  viewMoreFolderId?: number | null | undefined;
  showViewMore: boolean;
  handleToggleViewMore?: () => void;
  handleSetViewMoreFolderId?: (folder_id: number | null | undefined) => void;
  handleSetRenameModalData?: (folderData: childFolderType) => void;
  toggleRenameFolderModal?: () => void;
  isRenameFolderPresent?: boolean;
  setSingleFolderData?: any;
  singleFolderData?: any;
  persistFolderData?: any;
  setPersistFolderData?: any;
  setCheckingBack?: React.Dispatch<React.SetStateAction<boolean>>;
  checkingBack?: boolean;
  setSearchData?: React.Dispatch<React.SetStateAction<string>>;
  setShowSearchData?: React.Dispatch<React.SetStateAction<string>>;
  childFolders: any;
  getImageDetails?: (url: ImageDataType) => void;
  setShowViewMoreFiles: React.Dispatch<React.SetStateAction<boolean>>;
  handleDeleteFileAndFolder?: (folderData: childFolderType) => void;
  isFileAndFolderDelete?: boolean;
  handleHideFileFolder?: (data: childFolderType) => void;
  handleUnHideFileFolder?: (data: childFolderType) => void;
  isHideAndShowFileFolderPresent?: boolean;
  isParrentHide:number|null;
};

type ViewMoreAppProps = {
  fileData: any;
  handleToggleViewMoreFiles?: () => void;
  handleSetFileRenameModalData?: (data: any) => void;
  type: string;
};

type ViewMoreFolderAppProps = {
  folderData: childFolderType;
  handleToggleViewMore?: () => void;
  handleSetRenameModalData?: (folderData: childFolderType) => void;
  toggleRenameFolderModal?: () => void;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const FileFolderTableViewData = ({
  tableHeader,
  childFiles,
  handleSetViewMoreFileId,
  handleToggleViewMoreFiles,
  toggleRenameFileModal,
  showViewMoreFiles,
  viewMoreFileId,
  handleSetFileRenameModalData,
  type,
  showDeleteIcon,
  singleFolderData,
  client_code,
  folder,
  folderId,
  flag,
  setFlag,
  history,
  company_name,
  showViewMore,
  handleToggleViewMore,
  handleSetViewMoreFolderId,
  viewMoreFolderId,
  handleSetRenameModalData,
  toggleRenameFolderModal,
  isRenameFolderPresent,
  setSingleFolderData,
  persistFolderData,
  setPersistFolderData,
  setCheckingBack,
  checkingBack,
  setSearchData,
  setShowSearchData,
  childFolders,
  getImageDetails,
  setShowViewMoreFiles,
  handleDeleteFileAndFolder,
  isFileAndFolderDelete,
  handleHideFileFolder,
  handleUnHideFileFolder,
  isHideAndShowFileFolderPresent,
  isParrentHide
}: Appprops) => {
  const returnIcon = (fileType: string) => {
    switch (fileType) {
      case "pptx":
      case "ppt":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case "application/vnd.ms-powerpoint":
        return Ppt;
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "application/msword":
        return Word;
      case "application/pdf":
        return Pdf;
      case "image/jpeg":
      case "image/jpg":
        return JPG;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
      case "application/csv":
      case "text/x-csv":
      case "application/x-csv":
      case "text/csv":
        return Excel;
      case "image/png":
        return Png;
      default:
        return ImageBlank;
    }
  };

  const openRenameModal = (folderData: any) => {
    toggleRenameFolderModal && toggleRenameFolderModal();
    handleSetRenameModalData && handleSetRenameModalData(folderData);
  };

  const handleViewMoreClick = (
    e: any,
    document_id: number | null | undefined
  ) => {
    e.stopPropagation();
    handleToggleViewMoreFiles && handleToggleViewMoreFiles();
    handleSetViewMoreFileId && handleSetViewMoreFileId(document_id);
  };
  const renderData = (data: ImageDataType) => {
    getImageDetails && getImageDetails(data);
  };
  const renderRenameToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        Rename
      </Tooltip>
    );
  };
  const handleDownload = async (fileUrl: string, fileName: string) => {
      const response = await fetch(`${blobBaseUrl}${fileUrl}?${blobToken}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "downloaded_file"; 
      document.body.appendChild(a);
      a.click();
      a.remove();  
  
      window.URL.revokeObjectURL(url);  
  
  };
  const handleRenameFileData = (data: AnyAaaaRecord) => {
    handleToggleViewMoreFiles && handleToggleViewMoreFiles();
    toggleRenameFileModal && toggleRenameFileModal();
    handleSetFileRenameModalData && handleSetFileRenameModalData(data);
  };
  const handleRenameFolderData = (data: any) => {
    openRenameModal(data);
  };

  return (
    <>
      {/* ////folder data map/// */}
      {childFolders?.length && childFolders?.length > 0
        ? childFolders?.map((data: any) => {
            const finalLink = {
              pathname: `/file-manager/${client_code}/folder/${data.id}`,
              state: { client_code, company_name, folder: data },
            };
            return (
              <tr style={{ backgroundColor: data?.is_hidden ? "#f4f6f8" : "" }}>
                {tableHeader &&
                  tableHeader?.length > 0 &&
                  tableHeader?.map((item: any) => {
                    if (item.value === "name") {
                      return (
                        <td
                          className="text-start"
                          style={{ maxWidth: "180px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2%",
                              wordBreak: "break-word",
                            }}
                          >
                            <img
                              style={{ width: "15.7px", height: "21px" }}
                              src={FolderIcon}
                              alt="icon"
                            />
                            <Link
                              to={finalLink}
                              style={{
                                width: "100%",
                                cursor: "pointer",
                                textDecoration: "none",
                                color: "black",
                              }}
                              className="file-manager-folder-link"
                              onClick={() => {
                                setSearchData && setSearchData("");
                                setShowSearchData && setShowSearchData("");
                                setShowViewMoreFiles(false);
                              }}
                            >
                              <span>{data?.name ? data?.name : "NA"}</span>
                            </Link>
                          </div>
                        </td>
                      );
                    } else if (item.value === "updated_by") {
                      return (
                        <td className="text-start" style={{ width: "80px" }}>
                          <span>
                            {data?.updated_by_name
                              ? data?.updated_by_name
                              : "NA"}
                          </span>
                        </td>
                      );
                    } else if (item.value === "uploaded_on") {
                      return (
                        <td className="text-start">
                          {!data?.modified_on
                            ? "NA"
                            : moment
                                .utc(data?.modified_on, "YYYY-MM-DD HH:mm:ss")
                                .local()
                                .format("DD-MM-YY [at] hh:mmA")}
                        </td>
                      );
                    } else if (item.value === "action") {
                      return (
                        <td
                          style={{
                            textAlign: "start",
                            maxWidth: "120px",
                          }}
                        >
                          {isRenameFolderPresent && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                gap: "5%",
                              }}
                            >
                              {
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      position: "relative",
                                      gap: "20px",
                                    }}
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        <Tooltip id="button-view-open-item">
                                          Rename Folder
                                        </Tooltip>
                                      }
                                    >
                                      <img
                                        src={RenameFolderIcon}
                                        alt="rename"
                                        className="pointer"
                                        onClick={() => {
                                          handleRenameFolderData(data);
                                        }}
                                      />
                                    </OverlayTrigger>

                                    {isFileAndFolderDelete && (
                                      <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 250 }}
                                        overlay={
                                          <Tooltip id="button-view-open-item">
                                            Delete Folder
                                          </Tooltip>
                                        }
                                      >
                                        <img
                                          src={deleteIcon}
                                          alt="delete"
                                          className="pointer"
                                          onClick={() =>
                                            handleDeleteFileAndFolder?.(data)
                                          }
                                        />
                                      </OverlayTrigger>
                                    )}
                                    {isHideAndShowFileFolderPresent&&isParrentHide&&data?.parent_id!==0?null:isHideAndShowFileFolderPresent && (
                                      <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 250 }}
                                        overlay={
                                          <Tooltip id="button-view-open-item">
                                            <div className="d-flex flex-column">
                                              <span
                                                style={{
                                                  fontSize: "13px",
                                                  color: "#ffffff",
                                                  fontWeight: "600",
                                                }}
                                              >
                                                {data?.is_hidden
                                                  ? "Folder is Hidden."
                                                  : "Folder is Visible."}
                                              </span>
                                              <span
                                                style={{
                                                  fontSize: "12px",
                                                  color: "#ffffff",
                                                  fontWeight: "normal",
                                                }}
                                              >
                                                {data?.is_hidden
                                                  ? "Click on button to show folder."
                                                  : "Click on button to hide folder."}
                                              </span>
                                            </div>
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                       className="pointer"

                                          style={{
                                            display: "flex",
                                            border: "1px solid #bfcbe1",
                                            padding: "6px 8px",
                                            borderRadius: "5px",
                                            width: "125px",
                                            justifyContent: "center",
                                          }}
                                          onClick={() =>
                                            {
                                              if (data?.is_hidden) {
                                                handleUnHideFileFolder?.(
                                                  data
                                                );
                                              } else {
                                                handleHideFileFolder?.(data);
                                              }
                                            }
                                          }
                                        >
                                          <img
                                            src={
                                              data?.is_hidden
                                                ? grayViewIcon
                                                : HideIcon
                                            }
                                            alt="hide"
                                          />
                                          <span
                                            style={{
                                              color: "#6e7491",
                                              fontSize: "12px",
                                              fontWeight: "500",
                                              marginBottom: "-5px",
                                              marginLeft: "9px",
                                            }}
                                          >
                                            {data?.is_hidden
                                              ? "Show Folder"
                                              : "Hide Folder"}
                                          </span>
                                        </span>
                                      </OverlayTrigger>
                                    )}
                                  </div>
                                </>
                              }
                            </div>
                          )}
                        </td>
                      );
                    }
                  })}
              </tr>
            );
          })
        : ""}

      {/* ///file data map // */}
      {childFiles?.length && childFiles?.length > 0
        ? childFiles?.map((data: any) => {
            return (
              <tr style={{ backgroundColor: data?.is_hidden ? "#f4f6f8" : "" }}>
                {tableHeader &&
                  tableHeader?.length > 0 &&
                  tableHeader?.map((item: any) => {
                    if (item.value === "name") {
                      return (
                        <td
                          className="text-start"
                          style={{ maxWidth: "180px" }}
                        >
                          <div
                            onClick={() => {
                              renderData({
                                imageUrl:
                                  blobBaseUrl +
                                  data["file_url"] +
                                  "?" +
                                  blobToken,
                                downloadImage: data["file_url"],
                                fileType: data?.file_type,
                                finalFileName: data?.file_name,
                                updateBy: data?.updated_by_name,
                                updatedAt: moment
                                  .utc(data?.created_at)
                                  .local()
                                  .format("DD-MM-YYYY, h:mm a"),
                              });
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2%",
                              wordBreak: "break-word",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              style={{ width: "22.7px", height: "24px" }}
                              src={returnIcon(data?.file_type)}
                              alt="icon"
                            />
                            <span>
                              {data?.file_name ? data?.file_name : "NA"}
                            </span>
                          </div>
                        </td>
                      );
                    } else if (item.value === "updated_by") {
                      return (
                        <td className="text-start" style={{ width: "80px" }}>
                          <span>
                            {data?.updated_by_name
                              ? data?.updated_by_name
                              : "NA"}
                          </span>
                        </td>
                      );
                    } else if (item.value === "uploaded_on") {
                      return (
                        <td className="text-start">
                          {!data?.created_at
                            ? "NA"
                            : moment
                                .utc(data?.created_at, "YYYY-MM-DD HH:mm:ss")
                                .local()
                                .format("DD-MM-YY [at] hh:mmA")}
                        </td>
                      );
                    } else if (item.value === "action") {
                      return (
                        <td
                          style={{
                            textAlign: "start",
                            maxWidth: "120px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              gap: "5%",
                            }}
                          >
                            {blobBaseUrl && data?.file_url && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    position: "relative",
                                    gap: "20px",
                                  }}
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={
                                      <Tooltip id="button-view-open-item">
                                        Download File
                                      </Tooltip>
                                    }
                                  >
                                    <a
                                onClick={() => handleDownload(data?.file_url, data?.file_name)}

                                      style={{
                                        textDecoration: "none",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <img
                                        src={GreyDownloadIcon}
                                        alt="download-icon"
                                      />
                                    </a>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={
                                      <Tooltip id="button-view-open-item">
                                        Rename File
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src={RenameFolderIcon}
                                      alt="rename"
                                      className="pointer"
                                      onClick={() => {
                                        handleRenameFileData(data);
                                      }}
                                    />
                                  </OverlayTrigger>
                                  {isFileAndFolderDelete && (
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        <Tooltip id="button-view-open-item">
                                          Delete File
                                        </Tooltip>
                                      }
                                    >
                                      <img
                                        src={deleteIcon}
                                        alt="delete"
                                        className="pointer"
                                        onClick={() =>
                                          handleDeleteFileAndFolder?.(data)
                                        }
                                      />
                                    </OverlayTrigger>
                                  )}
                                  {isHideAndShowFileFolderPresent&&isParrentHide&&data?.parent_id!==0?null:isHideAndShowFileFolderPresent && (
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 250 }}
                                      overlay={
                                        <Tooltip id="button-view-open-item">
                                          <div className="d-flex flex-column">
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                color: "#ffffff",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {data?.is_hidden
                                                ? "File is Hidden."
                                                : "File is Visible."}
                                            </span>
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                color: "#ffffff",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              {data?.is_hidden
                                                ? "Click on button to show file."
                                                : "Click on button to hide file."}
                                            </span>
                                          </div>
                                        </Tooltip>
                                      }
                                    >
                                      <span
                                      className="pointer"

                                        style={{
                                          display: "flex",
                                          border: "1px solid #bfcbe1",
                                          padding: "6px 8px",
                                          borderRadius: "5px",
                                          width: "120px",
                                          justifyContent: "center",
                                        }}
                                        onClick={() =>
                                          {
                                            if (data?.is_hidden) {
                                              handleUnHideFileFolder?.(data);
                                            } else {
                                              handleHideFileFolder?.(data);
                                            }
                                          }
                                        }
                                      >
                                        <img
                                          src={
                                            data?.is_hidden
                                              ? grayViewIcon
                                              : HideIcon
                                          }
                                          alt="hide"
                                        />
                                        <p
                                          style={{
                                            color: "#6e7491",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            marginBottom: "-5px",
                                            marginLeft: "9px",
                                          }}
                                        >
                                          {data?.is_hidden
                                            ? "Show File"
                                            : "Hide File"}
                                        </p>
                                      </span>
                                    </OverlayTrigger>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </td>
                      );
                    }
                  })}
              </tr>
            );
          })
        : ""}
    </>
  );
};

export default FileFolderTableViewData;
